import * as forge from 'node-forge';
import { Storage } from '@ionic/storage';
import { Injectable } from '@angular/core';
import { RequestService } from '../services/request.service';
// import { AuthenticationService } from '../services/authentication.service';



@Injectable({
  providedIn: 'root',
})
export class EncryptionService {

  constructor(private storage: Storage, private request : RequestService) {

  }

  async generatekeyPairWithReturn(password: string){
    // console.info("ok");
    // Controlla se esiste già una coppia di chiavi
    const existingPrivateKey = await this.storage.get('privateRecoveryKey');
    if (existingPrivateKey) {
      // console.info("esco");

      //console.log("Coppia di chiavi RSA già esistente!");
      return;
    }
    // console.info("ok1");


    // Genera una nuova coppia di chiavi RSA (2048 bit)
    const keyPair = forge.pki.rsa.generateKeyPair({ bits: 2048 });

    const publicKeyPem = forge.pki.publicKeyToPem(keyPair.publicKey);
    const privateKeyPem = forge.pki.privateKeyToPem(keyPair.privateKey);

    const recoveryKey = this.generateRecoveryKey(privateKeyPem, password);
    
    const formData = new FormData();
    formData.append("_privateRecoveryKey", recoveryKey);
    formData.append("_publicKey", publicKeyPem);
    formData.append("_password", password);
    // console.info("ok2");

    return formData;
  }

  async generateKeyPair(password: string) {
    // Controlla se esiste già una coppia di chiavi
    const existingPrivateKey = await this.storage.get('privateRecoveryKey');
    if (existingPrivateKey) {
      //console.log("Coppia di chiavi RSA già esistente!");
      return;
    }

    // Genera una nuova coppia di chiavi RSA (2048 bit)
    const keyPair = forge.pki.rsa.generateKeyPair({ bits: 2048 });

    const publicKeyPem = forge.pki.publicKeyToPem(keyPair.publicKey);
    const privateKeyPem = forge.pki.privateKeyToPem(keyPair.privateKey);

    const recoveryKey = this.generateRecoveryKey(privateKeyPem, password);
    
    const formData = new FormData();
    formData.append("_privateRecoveryKey", recoveryKey);
    formData.append("_publicKey", publicKeyPem);


    this.request.post({
      path:"/setChiavi",
      data:formData,
      handler:async (response)=>{ 
        await this.storage.set('privateRecoveryKey', this.encryptStringa(recoveryKey));
        await this.storage.set('publicKey', this.encryptStringa(publicKeyPem));
        // console.info(response["_msg"]);
      },
      error:(error)=>{ 
        // console.info(error);
        // this.errore = error.error["_msg"];
      },
      // httpHeaders:this.request.createHeader()
    })
/*
    const isAuthenticated = await this.auth.isAuthenticated();

    if (isAuthenticated) {
      // Salva la chiave privata in Secure Storage (mai inviarla al server)
      await this.storage.set('privateRecoveryKey', recoveryKey);
      await this.storage.set('publicKey', publicKeyPem);
    }

*/
    // console.log("Nuova coppia di chiavi generata!");
    // console.log("Chiave pubblica:", publicKeyPem);
    
  }
/*
  async getPublicKey(): Promise<string> {
    return await this.storage.get('publicKey');
  }

  async getPrivateKey(): Promise<string> {
    return await this.storage.get('privateKey');
  }
*/

  async getPrivateKey(): Promise<string> {
    const recoveryEncrypt =  await this.storage.get('privateRecoveryKey');
    const recovery = this.decryptStringa(recoveryEncrypt);
    const pswEncrypt =  await this.storage.get('psw');
    const psw = this.decryptStringa(pswEncrypt);
    return this.recoverPrivateKey(recovery, psw);
  }

  generateRecoveryKey(privateKey: string, password: string): string {
    // Genera un hash della password
    const hash = forge.md.sha256.create().update(password).digest().toHex();
    // Combina l'hash della password con la chiave privata
    const recoveryKey = forge.util.encode64(hash + privateKey);
    return recoveryKey;
  }

  encryptStringa(stringa:string): string{
    const chiave = "5~vrJ-3=@2ShFOusZPPg9A=(e#o,EEos3V'%5\"3bsL,A1as^tJ2`pf-&E9`w(L}LnqnvVz5;8\i_nEIS@+LEPoxU'noO%~9UbN%4"
    const encryptString = forge.util.encode64(chiave + stringa);
    return encryptString;
  }

  decryptStringa(stringa:string): string{
    const chiave = "5~vrJ-3=@2ShFOusZPPg9A=(e#o,EEos3V'%5\"3bsL,A1as^tJ2`pf-&E9`w(L}LnqnvVz5;8\i_nEIS@+LEPoxU'noO%~9UbN%4"
    const decoded = forge.util.decode64(stringa);
    if (decoded.startsWith(chiave)) {
      return decoded.substring(chiave.length);
    }
    return '';
  }

  recoverPrivateKey(recoveryKey: string, password: string): string {
    const hash = forge.md.sha256.create().update(password).digest().toHex();
    const decoded = forge.util.decode64(recoveryKey);
    if (decoded.startsWith(hash)) {
      return decoded.substring(hash.length); // Restituisce la chiave privata originale
    }
    return '';
  }

  encryptMessage(message: string, recipientPublicKeyPem: string): Promise<string> {
    const recipientPublicKey = forge.pki.publicKeyFromPem(recipientPublicKeyPem);
    const encrypted = recipientPublicKey.encrypt(forge.util.encodeUtf8(message), 'RSA-OAEP');
    return forge.util.encode64(encrypted);
  }

  async decryptMessage(encryptedMessage: string): Promise<string> {
    const privateKeyPem = await this.getPrivateKey();
    // console.info("chiave recuperata");
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
    // console.info("chiave trasformata");
    const encryptedBytes = forge.util.decode64(encryptedMessage);
    // console.info("mssaggio decodificato");
    const decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP');
    // console.info("mssaggio decriptato");
    return forge.util.decodeUtf8(decrypted);
  }

/*
  async encryptMessage(message: string, recipientPublicKeyPem: string): Promise<string> {
    const recipientPublicKey = forge.pki.publicKeyFromPem(recipientPublicKeyPem);
    const encrypted = recipientPublicKey.encrypt(forge.util.encodeUtf8(message), 'RSA-OAEP');
    return forge.util.encode64(encrypted);
  }

  async decryptMessage(encryptedMessage: string): Promise<string> {
    const privateKeyPem = await this.encryptionService.getPrivateKey();
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
    const encryptedBytes = forge.util.decode64(encryptedMessage);
    const decrypted = privateKey.decrypt(encryptedBytes, 'RSA-OAEP');
    return forge.util.decodeUtf8(decrypted);
  }

  generateRecoveryKey(privateKey: string, password: string): string {
  // Genera un hash della password
  const hash = forge.md.sha256.create().update(password).digest().toHex();
  // Combina l'hash della password con la chiave privata
  const recoveryKey = forge.util.encode64(hash + privateKey);
  return recoveryKey;
}

async saveRecoveryKey(password: string) {
  const privateKey = await this.encryptionService.getPrivateKey();
  const recoveryKey = this.generateRecoveryKey(privateKey, password);

  // Salva la chiave di recupero sul server (opzionale) o la mostra all'utente
  this.http.post('http://localhost:5000/save-recovery-key', { recoveryKey }).subscribe(() => {
    console.log("Chiave di recupero salvata!");
  });

  return recoveryKey; // Può essere mostrata all’utente per backup manuale
}

*/
}